#import "~/graphql/fragments/CraftLink.graphql"
#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"
#import "~/graphql/fragments/Entry/Cards/DefaultCard.graphql"

fragment ContentBlockContentOverview on contentBlocks_contentOverview_BlockType {
    anchorId
    anchorLabel

    contentOverview {
        manualOrAutomatic

        manuallySelectedEntries {
            id
            slug
            uri

            ... on default_Entry {
                ... DefaultCard
            }
        }

        sections
        limit

        entriesRelatedTo {
            id
        }

        entriesNotRelatedTo {
            id
        }
    }
}
